import { Banner } from "../../components/Banner/Banner.tsx";

export const Gallery = () => {
  return (
    <div className="gallery-wrapper">
      <Banner
        backgroundImageUrl="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-19_orig.jpg"
        title="Gallery"
        showcase
        centered
        shrinkOnMobile
      />

      <div className="gallery-container content-padding centered column">
        <img
          className="gallery-item"
          src="https://i.imgur.com/AhKrery.jpeg"
          alt="Gallery item 1"
        />
        <img
          className="gallery-item"
          src="https://i.imgur.com/QBD9tkZ.jpeg"
          alt="Gallery item 2"
        />
        <img
          className="gallery-item"
          src="https://i.imgur.com/A4TFBrD.jpeg"
          alt="Gallery item 3"
        />
        <img
          className="gallery-item"
          src="https://i.imgur.com/PQQyRPq.jpeg"
          alt="Gallery item 4"
        />
        <img
          className="gallery-item"
          src="https://i.imgur.com/OuVUISZ.jpeg"
          alt="Gallery item 5"
        />
        <img
          className="gallery-item"
          src="https://i.imgur.com/6XwA0bu.jpeg"
          alt="Gallery item 6"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-4_orig.jpg"
          alt="Gallery item 7"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-8_orig.jpg"
          alt="Gallery item 8"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-7_orig.jpg"
          alt="Gallery item 9"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/img-0032_orig.jpg"
          alt="Gallery item 10"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/published/unnamed-23.jpg?1711512255"
          alt="Gallery item 11"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-26_orig.jpg"
          alt="Gallery item 12"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-25_orig.jpg"
          alt="Gallery item 13"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-24_orig.jpg"
          alt="Gallery item 14"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-27_orig.jpg"
          alt="Gallery item 15"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/img-4953_orig.jpg"
          alt="Gallery item 16"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/img-0065_orig.jpg"
          alt="Gallery item 17"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/untitled-2_orig.jpg"
          alt="Gallery item 18"
        />
        <img
          className="gallery-item"
          src="https://charproof.weebly.com/uploads/1/4/9/1/149102767/charproof-coffee-table-and-stumps_orig.png"
          alt="Gallery item 19"
        />
      </div>
    </div>
  );
};
